/*
 * Copyright (c) 2022. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Persona} from "./persona.model";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";

@BasicEntity({
    name: 'Persona contacto',
    endpoint: 'contactos',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'lectura',
    type: 'Contacto'
})
export class PersonaContacto extends Persona {

    @BasicProperty({
        name: 'Cargo',
        type: PropertyType.String(),
    })
    private _cargo: string;

    get cargo(): string {
        return this._cargo;
    }

    set cargo(value: string) {
        this._cargo = value;
    }
}
